import { ApiError } from "../api";

export type RequestOutcome =
  | "unauthorized"
  | "forbidden"
  | "notFound"
  | "conflict"
  | "unknown"
  | "unavailable"
  | "invalid";

export function mapRequestOutcome(error: unknown): RequestOutcome {
  if (!(error instanceof ApiError)) return "unavailable";
  if (error.kind === "unauthorized") return "unauthorized";
  if (error.kind === "forbidden") return "forbidden";
  if (error.kind === "not-found") return "notFound";
  if (error.kind === "conflict") return "conflict";
  if (error.kind === "outcome-unknown") return "unknown";
  if (error.kind === "rejected") return "invalid";
  return "unavailable";
}

export function isCancelledRequest(error: unknown) {
  return error instanceof ApiError && error.kind === "cancelled";
}
